import Link from 'next/link';
import { memo } from 'react';

import { ServerLink } from '../../helpers';
import { AuthButtons } from '../AuthButtons';
import { HeaderSkeleton } from '../HeaderSkeleton';
import { Logo } from '../Logo';
import { UserPanel } from '../UserBlock';
import { AnalyticsEventName } from '@/api/analytics';
import { Menu, MenuProps } from '@/components/general/Menu';
import { LabelsSection } from '@/components/LabelsSection';
import { Support } from '@/components/Support';
import { SwitchLanguage } from '@/components/SwitchLanguage';
import { generateLink } from '@/helpers/common';
import { useAnalytics } from '@/hooks/analytics';
import { useCommonStore } from '@/store';

import {
  ScAddons,
  ScHeaderButtonsGroup,
  ScHeaderColLeft,
  ScHeaderColRight,
  ScHeaderLogo,
  ScHeaderRow,
} from '../styled';

interface IHeaderContent {
  locale: string;
  links: ServerLink[];
  hostname: string;
}

export const HeaderContent = memo(
  ({ locale, links, hostname }: IHeaderContent) => {
    const isAuthenticated = useCommonStore.use.isAuthenticated();
    const pendingUserPure = useCommonStore.use.pendingUserPure();

    const { sendEventToAnalytics } = useAnalytics();

    const handleLUHomeClick = () => {
      sendEventToAnalytics({ name: AnalyticsEventName.LU_HOME_TOP });
    };

    return (
      <ScHeaderRow>
        <ScHeaderColLeft>
          <ScHeaderLogo>
            <Link
              id="logo"
              href={generateLink('/', locale)}
              onClick={handleLUHomeClick}
            >
              <Logo />
            </Link>
          </ScHeaderLogo>
          <Menu withStripe links={links} locale={locale} hostname={hostname} />
        </ScHeaderColLeft>
        {pendingUserPure ? (
          <ScHeaderColRight>
            <HeaderSkeleton />
          </ScHeaderColRight>
        ) : (
          <ScHeaderColRight>
            <ScHeaderButtonsGroup>
              <LabelsSection />
              {isAuthenticated ? <UserPanel /> : <AuthButtons />}
              {!isAuthenticated && <SwitchLanguage variant="compact" />}
              <ScAddons>
                <Support
                  eventName={
                    AnalyticsEventName.HEADER__BUTTONS__SUPPORT_BUTTON__CLICK
                  }
                />
              </ScAddons>
            </ScHeaderButtonsGroup>
          </ScHeaderColRight>
        )}
      </ScHeaderRow>
    );
  }
);
